import { render, staticRenderFns } from "./CartPendingOrdersRemote.vue?vue&type=template&id=950c8b50"
import script from "./CartPendingOrdersRemote.vue?vue&type=script&lang=js"
export * from "./CartPendingOrdersRemote.vue?vue&type=script&lang=js"
import style0 from "./CartPendingOrdersRemote.vue?vue&type=style&index=0&id=950c8b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports